import { ApplicationCode } from "constants/auth";

import Authorization from "features/authorization/Authorization";

import { RequestCreateComponent } from "../components/RequestCreate";

export const RequestCreate = () => {
  return (
    <Authorization permission={[ApplicationCode.Request]}>
      <RequestCreateComponent />
    </Authorization>
  );
};
